import { render, staticRenderFns } from "./SwiperCenter.vue?vue&type=template&id=710a0a72"
import script from "./SwiperCenter.vue?vue&type=script&lang=js"
export * from "./SwiperCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports